import React from 'react';

import { Name } from './styles';

type GroupNameProps = {
    name?: string;
};
export const GroupName = ({ name, ...others }: GroupNameProps) => <Name {...others}>{name}</Name>;
